import { forwardRef, type InputHTMLAttributes } from 'react'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string
  description?: string
  size?: 'sm' | 'md'
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  description,
  size = 'md',
  className,
  ...props
}, ref) => {
  return (
    <label className={`v3-checkbox-wrap ${size === 'sm' ? 'v3-checkbox-sm' : ''} ${className || ''}`}>
      <input ref={ref} type="checkbox" className="v3-checkbox" {...props} />
      <span className="v3-checkbox-box">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20,6 9,17 4,12" />
        </svg>
      </span>
      {(label || description) && (
        <span className="v3-checkbox-text">
          {label && <span className="v3-checkbox-label">{label}</span>}
          {description && <span className="v3-checkbox-desc">{description}</span>}
        </span>
      )}
    </label>
  )
})

Checkbox.displayName = 'Checkbox'
